export default "__VITE_ASSET__ed9fed9e__"